<template>
  <div class="block-text-image block-text-image--loud">
    <div class="block-text-image__main">
      <div class="block-text-image__head">
        <h1 class="block-text-image__title">{{ $t('home.title') }}</h1>
      </div>
      <div class="block-text-image__content">
        <div class="block-text-image__text">
          <p>{{ $t('home.paragraph') }}</p>
          <p>{{ $t('home.prelist') }}</p>
          <ul>
            <li>{{ $t('home.listitem1') }}</li>
            <li>{{ $t('home.listitem2') }}</li>
            <li>{{ $t('home.listitem3') }}</li>
          </ul>
          <div class="block-text-image__button">
            <a href="#" class="btn btn-fullwidth btn-gradient" @click="goToSurvey">{{ $t('app.buttonSurvey') }}</a>
          </div>
        </div>
        <div class="block-text-image__image">
          <div class="block-text-image__picture-1">
            <!-- PICTURE 1 -->
            <img srcset="@/assets/images/reporting-preview-1.png 623w,
            @/assets/images/reporting-preview-1@2x.png 1246w"
            sizes="(max-width: 480px) 240px,
            800px"
            src="@/assets/images/reporting-preview-1.png" />
          </div>
          <div class="block-text-image__picture-2">
            <!-- PICTURE 2 -->
            <img srcset="@/assets/images/reporting-preview-2.png 453w,
            @/assets/images/reporting-preview-2@2x.png 906w"
            sizes="(max-width: 480px) 240px,
            800px"
            src="@/assets/images/reporting-preview-2.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToSurveyMixin from '@/mixins/goToSurvey';

export default {
  name: 'home',
  mixins: [goToSurveyMixin],
};
</script>
